var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatAiIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_487_4227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.00006C24.8219 2.00006 31.9999 8.28004 31.9999 16C31.9999 19.164 30.7919 22.2 28.5739 24.64L31.7579 28.348C32.0139 28.644 32.0719 29.062 31.9079 29.416C31.7459 29.772 31.3899 30 30.9999 30H16C7.17798 30 9.53674e-06 23.72 9.53674e-06 16C9.53674e-06 8.28004 7.17798 2.00006 16 2.00006Z",
    fill: "url(#paint0_linear_487_4227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18C14.8954 18 14 17.1046 14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16C18 17.1046 17.1046 18 16 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 18C22.8954 18 22 17.1046 22 16C22 14.8954 22.8954 14 24 14C25.1046 14 26 14.8954 26 16C26 17.1046 25.1046 18 24 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 18C6.89544 18 6.00002 17.1046 6.00002 16C6.00002 14.8954 6.89544 14 8.00001 14C9.10457 14 10 14.8954 10 16C10 17.1046 9.10457 18 8.00001 18Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_487_4227",
    x1: 24.5,
    y1: 25.5,
    x2: 10.6696,
    y2: 0.44204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_487_4227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 1 32 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAiIconActive);
export default __webpack_public_path__ + "static/media/chat_AI_icon_active.adf88e5168c1b94fbbfda4bc888f026d.svg";
export { ForwardRef as ReactComponent };